import { AgencyHiringConstantMapping } from "./agencyHiringConstantMapping";

/**
 * Americas (AM) Agency Organization Name to Domain Name mappings, as they appear in ROMP
 */
export const AGENCY_HIRING_CONSTANT_MAPPING_AM: AgencyHiringConstantMapping = {
  // Add AM-specific agency mappings here
  // Example: "Americas Agency Name": "americas-agency-domain",
};
